import { getUpdatedPath } from "@/route-helpers";
import { LinkProps, Link, NavLink } from "react-router";
import { cn } from "@/lib/utils";

export const NewLink = ({
    to,
    useNavlink = false,
    isTruncated = false,
    className,
    ...props
}: LinkProps &
    React.RefAttributes<HTMLAnchorElement> & {
        useNavlink?: boolean;
        isTruncated?: boolean;
    }) => {
    const LinkElement = useNavlink ? NavLink : Link;
    const combinedClassName = cn(
        isTruncated && "max-w-[50ch] truncate block",
        className,
    );

    if (typeof to !== "number") {
        if (typeof to === "string") {
            const updatedPath = getUpdatedPath(to);
            if (updatedPath && updatedPath !== to) {
                return (
                    <LinkElement
                        to={updatedPath}
                        className={combinedClassName}
                        {...props}
                    />
                );
            }
        } else if (to.pathname) {
            const updatedPath = getUpdatedPath(to.pathname);
            if (updatedPath && updatedPath !== to.pathname) {
                return (
                    <LinkElement
                        to={{
                            ...to,
                            pathname: updatedPath,
                        }}
                        className={combinedClassName}
                        {...props}
                    />
                );
            }
        }
    }

    return <LinkElement to={to} className={combinedClassName} {...props} />;
};
